export function initAccordions() {
    const accordionWraps = $('.accordion');
    if (accordionWraps.length) {
        accordionWraps.each(function () {

            const headers = $(this).find('> h3');
            let active = false;
            headers.each(function (idx) {
                if ($(this).hasClass('default-expanded')) {
                    active = idx;
                }
            });

            $(this).accordion({
                collapsible: true,
                heightStyle: 'content',
                active: active,
            });
        });
    }
}

export function initCounters() {
    const counters = $('.counter');
    if (!counters.length) {
        return;
    }

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const {target} = entry;
                const numberEl = $(target).find('.counter-item-number');
                const targetNumber = numberEl.data('number');

                $({counter: 0}).animate({counter: targetNumber}, {
                    duration: 1500,
                    easing: 'swing',
                    step: function (now) {
                        numberEl.text(Math.ceil(now));
                    }
                });
            }
        });
    }, {
        threshold: 1
    });

    counters.each(function () {
        const items = $(this).find('.counter-item');
        items.each(function () {
            observer.observe(this);
        });
    });
}

let headerEl;
let headerNav;
let breakpoint = 0;
const headerPadding = 32;

export function checkMobileHeader() {
    const docEl = $(document.documentElement);
    if (!headerEl) {
        headerEl = $('.page-header');
        headerNav = headerEl.find('.page-header-nav-inner');
    }

    if ((breakpoint === 0 && document.body.clientWidth < headerNav[0].scrollWidth + headerPadding)
        || document.body.clientWidth < breakpoint
        || window.innerWidth < 1200) {

        if (breakpoint === 0) {
            breakpoint = headerNav[0].scrollWidth + headerPadding;
        }
        docEl.addClass('mobile-header');
    } else {
        docEl.removeClass('mobile-header');
    }
}

export function initBannerSwiper() {
    const element = $('.header-banner .swiper')[0];

    if (!element) {
        return;
    }

    element.addEventListener('c3.swiper.initialized', (e) => {
        const {swiper} = e.detail;

        swiper.on('slideChange', _updatePagination);

        function _updatePagination() {
            swiper.pagination.$el.addClass('first-slide-over');
            swiper.off('slideChange', _updatePagination);
        }
    });
}